var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyData"},[_c('img',{attrs:{"src":require("../../../assets/images/winterGame/emptyData.png")}}),_c('p',[_vm._v(_vm._s(_vm.emptyTip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }